export const isStandaloneApp = (): boolean => {
  const subdomain = process.env.Ai_SAAS_SUBDOMAIN;
  const currentHost = window.location.origin;
  return currentHost === subdomain;
};

/** 获取登录后的默认首页路径 */
export const getHomePath = (): string => {
  return isStandaloneApp() ? '/app/mine' : '/org/user';
};
